/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/bundles/utils/on-dom-content-loaded.js":
/*!*******************************************************!*\
  !*** ./src/js/bundles/utils/on-dom-content-loaded.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   onDOMContentLoaded: () => (/* binding */ onDOMContentLoaded)
/* harmony export */ });
const onDOMContentLoaded = cb => {
  document.addEventListener('DOMContentLoaded', cb);
};

/***/ }),

/***/ "./src/styles/templates/page.careers-landing.scss":
/*!********************************************************!*\
  !*** ./src/styles/templates/page.careers-landing.scss ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!**********************************************************!*\
  !*** ./src/js/bundles/templates/page.careers-landing.js ***!
  \**********************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var Styles_templates_page_careers_landing_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! Styles/templates/page.careers-landing.scss */ "./src/styles/templates/page.careers-landing.scss");
/* harmony import */ var _utils_on_dom_content_loaded__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/on-dom-content-loaded */ "./src/js/bundles/utils/on-dom-content-loaded.js");


const url = 'https://boards-api.greenhouse.io/v1/boards/momentous/jobs?content=true';

// Function to fetch JSON data
async function fetchJSONData() {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Check if the response is okay
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    document.querySelector('.job-search').addEventListener('input', () => {
      filterJobs(data.jobs);
    });
    createJobCards(data.jobs);
    const filters = extractUniqueValues(data.jobs, ['city']);
    createCheckboxFilters(filters, data.jobs);
  } catch (error) {
    console.error('Error fetching JSON data:', error);
  }
}
function extractUniqueValues(jobs, fields) {
  const uniqueValues = {};
  fields.forEach(field => {
    uniqueValues[field] = [...new Set(jobs.map(job => {
      if (field === 'city') {
        const locationName = job.location.name.split(',')[0].trim(); // Extract the city name
        return locationName;
      }
      return job[field];
    }).filter(value => value !== '')) // Filter out empty values
    ];
  });
  return uniqueValues;
}
function createCheckboxFilters(uniqueValues, jobs) {
  const filterContainer = document.querySelector('.filters__grid-item.col-filters .items-containers');
  filterContainer.innerHTML = '';
  Object.keys(uniqueValues).forEach(field => {
    const fieldContainer = document.createElement('div');
    fieldContainer.classList.add('filter-group');
    const header = document.createElement('h4');
    header.classList = 'filter-group-header';
    let textTitle = field.charAt(0).toUpperCase() + field.slice(1);
    if (field == 'city') textTitle = 'Location';
    if (field == 'type') textTitle = 'Job type ';
    header.textContent = textTitle;
    fieldContainer.appendChild(header);
    const itemContainer = document.createElement('div');
    itemContainer.classList.add('item-container');
    fieldContainer.appendChild(itemContainer);
    uniqueValues[field].forEach(value => {
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = `${field}-${value}`;
      checkbox.classList = 'btn-filter-checkbox';
      checkbox.name = field;
      checkbox.value = value;
      checkbox.addEventListener('change', () => filterJobs(jobs));
      const label = document.createElement('label');
      label.htmlFor = checkbox.id;
      label.textContent = value;
      const checkboxContainer = document.createElement('div');
      checkboxContainer.appendChild(checkbox);
      checkboxContainer.appendChild(label);
      fieldContainer.appendChild(checkboxContainer);
      itemContainer.appendChild(checkboxContainer);
    });
    fieldContainer.appendChild(itemContainer);
    filterContainer.appendChild(fieldContainer);
  });
}
function filterJobs(jobs) {
  const filters = {
    city: []
  };
  document.querySelectorAll('input.btn-filter-checkbox').forEach(checkbox => {
    if (checkbox.checked) {
      if (checkbox.name == 'city') {
        const getOnlyCity = checkbox.value.split(', ');
        filters[checkbox.name].push(getOnlyCity[0]);
      } else {
        filters[checkbox.name].push(checkbox.value);
      }
    }
  });
  const searchTerm = document.querySelector('.job-search').value.toLowerCase();
  const filteredJobs = jobs.filter(job => {
    const locationName = job.location.name.split(',')[0].trim();
    const matchesFilters = filters.city.length === 0 || filters.city.includes(locationName);
    const matchesSearchTerm = job.title.toLowerCase().includes(searchTerm);
    return matchesFilters && matchesSearchTerm;
  });
  createJobCards(filteredJobs);
}
function decodeHTML(html) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  return textarea.value;
}
const createJobCards = jobs => {
  const jobContainer = document.querySelector('.filters__grid-item.col-data');
  jobContainer.innerHTML = '';
  jobs.forEach(job => {
    const jobElement = document.createElement('div');
    jobElement.classList.add('job-item');
    jobElement.innerHTML = `
        <h4 class="job-title">${job.title}</h4>
        <p class="locale">
          <span class="type">Full Time</span>
          <span class="city">${job.location.name}</span>
        </p>
        <div class="container__btns">
          <a href="${job.absolute_url}" target="_blank" class="btn-top-link pointer button--primary flex items-center justify-between px-3.5 py-1.5 text-xs md:text-sm">
            Apply now
          </a>
          <button class="btn-top pointer button--primary flex items-center justify-between px-3.5 py-1.5 text-xs md:text-sm btn__show top">
            View Details
          </button>
        </div>
        <div class="job-description">
          <div>
          ${job.content ? `<div class="job-content">${decodeHTML(job.content)}</div>` : 'No description available'}
          </div>
          <div class="container__btns-button">
            <a href="${job.absolute_url}" target="_blank" class="btn-top-link pointer button--primary flex items-center justify-between px-3.5 py-1.5 text-xs md:text-sm">
              Apply now
            </a>
            <button class="btn-button pointer button--primary flex items-center justify-between px-3.5 py-1.5 text-xs md:text-sm btn__show button less">
              See Less
            </button>
          </div>
        </div>
      `;
    jobContainer.appendChild(jobElement);
  });
  if (!jobs?.length) {
    const jobItem = document.createElement('div');
    jobItem.classList.add('job-item');
    jobItem.innerHTML = `<div class="filters__not-found">No information found</div>`;
    jobContainer.appendChild(jobItem);
  }
  onHandleReedDetail();
  addLeesDescriptionJobEvent();
  addFilterGroupEventListeners();
};
function slugURL(string) {
  string = string.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, ' ').toLowerCase();
  string = string.replace(/^\s+|\s+$/gm, '');
  string = string.replace(/\s+/g, '-');
  return string;
}
function handleLeesDescriptionJob(element) {
  const container = element.parentElement.parentElement;
  if (container) {
    const item = container.parentElement;
    item.scrollIntoView(true);
    container.classList.toggle('show');
    const buttonTop = container.parentElement.querySelector('.top.less');
    buttonTop.classList.toggle('less');
    buttonTop.innerText = 'View Details';
  }
}
function addLeesDescriptionJobEvent() {
  const elements = document.querySelectorAll('.btn__show.button');
  elements.forEach(element => {
    element.addEventListener('click', () => {
      handleLeesDescriptionJob(element);
    });
  });
}
function onClickFilterGroup(ele) {
  ele.parentElement.classList.toggle('close');
  ele.nextElementSibling.classList.toggle('close');
}
function addFilterGroupEventListeners() {
  const headers = document.querySelectorAll('.filter-group-header');
  headers.forEach(header => {
    header.addEventListener('click', () => {
      onClickFilterGroup(header);
    });
  });
}
function onHandleReedDetail() {
  const accordionItems = document.querySelectorAll('.job-item');
  accordionItems.forEach(item => {
    const button = item.querySelector('.btn__show');
    button?.addEventListener('click', function () {
      const openItem = document.querySelector('.job-description.show');
      const container = button.parentElement.nextElementSibling;
      if (openItem && openItem != item.querySelector('.job-description')) {
        openItem.classList.remove('show');
        const buttonTop = openItem.parentElement.querySelector('.top.less');
        buttonTop.classList.toggle('less');
        buttonTop.innerText = 'View Details';
      }
      if (button.classList.contains('top')) {
        if (container) {
          container.classList.toggle('show');
          item.scrollIntoView(true);
        }
        let txt = button.innerText;
        button.innerText = txt == 'View Details' ? 'See Less' : 'View Details';
        button.classList.toggle('less');
      }
      if (button.classList.contains('button')) {
        if (container) {
          const item = container.parentElement;
          item.scrollIntoView(true);
          container.classList.add('show');
        }
      }
    });
  });
}
function handleResize() {
  const filterGroups = document.querySelectorAll('.items-containers .filter-group');
  const itemContainers = document.querySelectorAll('.items-containers .item-container');
  const width = window.innerWidth;
  filterGroups.forEach(item => {
    if (width <= 768) {
      item.classList.add('close');
    } else {
      item.classList.remove('close');
    }
  });
  itemContainers.forEach(item => {
    if (width <= 768) {
      item.classList.add('close');
    } else {
      item.classList.remove('close');
    }
  });
}
(0,_utils_on_dom_content_loaded__WEBPACK_IMPORTED_MODULE_1__.onDOMContentLoaded)(() => {
  handleResize();
  window.addEventListener('resize', handleResize);
  // getJobs(window._apiKeyJobs);
  fetchJSONData();
});
/******/ })()
;